import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Origins from "./pages/Origins";
import Session from "./pages/Session";
import MyStory from "./pages/MyStory";
import FaqPage from "./pages/FAQ";
import Contacts from "./pages/Contacts";
import FieldNotes from "./pages/FieldNotes";
import FieldNoteArticle from "./pages/FieldNoteArticle";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import Impressum from "./pages/Impressum";
import HomeDe from "./pages/de/Home";
import OriginsDe from "./pages/de/Origins";
import SessionDe from "./pages/de/Session";
import MyStoryDe from "./pages/de/MyStory";
import FaqPageDe from "./pages/de/FAQ";
import ContactsDe from "./pages/de/Contacts";
import { PaymentSuccessDe, PaymentCancelDe } from "./pages/de/PaymentResult";
import ImpressumDe from "./pages/de/Impressum";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/origins" element={<Origins />} />
          <Route path="/session" element={<Session />} />
          <Route path="/my-story" element={<MyStory />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/field-notes" element={<FieldNotes />} />
          <Route path="/field-notes/:slug" element={<FieldNoteArticle />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/impressum" element={<Impressum />} />

          {/* German routes */}
          <Route path="/de" element={<HomeDe />} />
          <Route path="/de/ursprunge" element={<OriginsDe />} />
          <Route path="/de/sitzung" element={<SessionDe />} />
          <Route path="/de/meine-geschichte" element={<MyStoryDe />} />
          <Route path="/de/faq" element={<FaqPageDe />} />
          <Route path="/de/kontakt" element={<ContactsDe />} />
          <Route path="/de/field-notes" element={<FieldNotes />} />
          <Route path="/de/field-notes/:slug" element={<FieldNoteArticle />} />
          <Route path="/de/zahlung/erfolg" element={<PaymentSuccessDe />} />
          <Route path="/de/zahlung/abbruch" element={<PaymentCancelDe />} />
          <Route path="/de/impressum" element={<ImpressumDe />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
